import type { ComponentProps } from 'react'
import React from 'react'
import { Modal as RacModal } from 'react-aria-components'

import { mergeClassNames } from '../utils'

interface ModalProps extends ComponentProps<typeof RacModal> {}
export const Modal = ({
  className,
  useCssAnimation = true,
  ...rest
}: ModalProps & { useCssAnimation?: boolean }) => {
  return (
    <RacModal
      className={({ isEntering, isExiting, ...other }) => {
        return mergeClassNames(
          isEntering &&
            useCssAnimation &&
            'tw-duration-300 tw-ease-out tw-animate-in tw-zoom-in-95',
          isExiting &&
            useCssAnimation &&
            'tw-duration-200 tw-ease-in tw-animate-out tw-zoom-out-95',
          typeof className === 'function'
            ? className({ isEntering, isExiting, ...other })
            : className,
        )
      }}
      {...rest}
    ></RacModal>
  )
}
